import ScoreInput from "pages/QuestionPage/questionCreation/ScoreInput/ScoreInput";

export default ScoreInput;
